import { render, staticRenderFns } from "./AdminsList.vue?vue&type=template&id=613e1601&"
import script from "./AdminsList.vue?vue&type=script&lang=js&"
export * from "./AdminsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports